// src/chatbot/faq.js
export const faq = {
    shipping: "We deliver within 3-5 business days. Orders are processed within 24 hours.",
    returns: "You can return products within 7 days of delivery. Please ensure the product is unused and in original packaging.",
    payment: "We accept UPI, Cards (Visa, Mastercard, Amex), and Cash on Delivery.",
    freeShipping: "Orders above $50 get free shipping.",
    contact: "You can reach us at support@shaazperfumes.com or call +1-800-SHAAZ"
};

export default faq;